import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ToolNotes.css";
import {
  setCommandType,
  resetOperation,
  setCommandMessage,
} from "../../../redux/operationSlice";
import { COMMANDS } from "../../../utils/commonProperties";

const ToolNotes = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const buttonSize = 30;
  const dispatch = useDispatch();
  const commandType = useSelector((state) => state.operation.commandType);

  useEffect(() => {
    if (commandType === COMMANDS.DRAW_CALLOUT) {
      setActiveButton("callout");
    } else {
      setActiveButton(null);
    }
  }, [commandType]);

  const handleClick = (tool) => {
    const alreadyActive = tool === activeButton;
    if (alreadyActive) {
      dispatch(resetOperation());
      setActiveButton(null);
    } else {
      setActiveButton(tool);
      if (tool === "callout") {
        dispatch(setCommandType(COMMANDS.DRAW_CALLOUT));
        dispatch(setCommandMessage("Dikkat cekmek istediginiz noktaya tiklayin"));
      }
    }
  };

  return (
    <div className={`toolNotes ${isOpen ? "open" : "closed"}`}>
      {isOpen && (
        <div className="toolNotes-left">
          <div className="toolNotesRow">
            <button
              className={`toolNotesButton ${activeButton === "callout" ? "active" : ""}`}
              style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
              onClick={() => handleClick("callout")}
              title="Callout Not Ekle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={buttonSize}
                height={buttonSize}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16v12H8l-4 4V4z" />
                <line x1="8" y1="8" x2="16" y2="8" />
                <line x1="8" y1="12" x2="12" y2="12" />
              </svg>
              <span className="toolNotesLabel">Callout</span>
            </button>
          </div>
        </div>
      )}
      <div className="toolNotes-toggle">
        <button
          className="toolButton toggleArrowButton"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? "◀" : "Not▶"}
        </button>
      </div>
    </div>
  );
};

export default ToolNotes;
